import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";

function NtDevopsSupportSection(props) {
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle style={{ fontSize: 26, fontWeight: "300" }}>
        DEV<NtText style={{ fontWeight: "800" }}>OPS</NtText>
      </NtSectionTitle>
      <NtSectionDescription
        style={{
          textAlign: "center",
          marginTop: 10,
          fontSize: 20,
          lineHeight: 26,
        }}
      >
        Certified support and maintenance of SuSE Rancher, HarvesterHCI,
        NVector, and other Kubernetes based tools and deployments
      </NtSectionDescription>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 100,
    paddingBottom: 100,
  },
});

export default NtDevopsSupportSection;
